import { useEffect, useState } from 'react';
import ChargerModule from '../../components/chargerModule';
import PillsSkeleton from '../../components/skeletonLoaders/PillsSkeleton';
import { getCategories } from '../../services/cataloge';
import { getCategoryPills, updatePills } from '../../services/pills';
import { ICategoryList } from '../../types/category';
import errorMessage from '../../utils/errorMessage';
import Properties from './components/Properties';
import TabsCategories from './components/TabsCategories';

const Pills = () => {
  const headerInfo = { title: 'Categorias', subtitle: '' };
  const infoSideBar = { position: 'category' };
  const [loading, setLoading] = useState<boolean>(false);
  const [categoryList, setCategoryList] = useState<ICategoryList>();
  const [selectId, setSelectId] = useState<number>(0);
  const [containsProps, setContainsProps] = useState<string[]>([]);
  const [available, setAvailable] = useState<string[]>([]);

  const getCategoriesData = async () => {
    setLoading(true);
    try {
      const categories = await getCategories();
      setCategoryList(categories);
      if (!selectId) {
        const defaultId = categories[0]?.id;
        if (defaultId) {
          setSelectId(defaultId);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      errorMessage();
    }
  };

  const handleChangSelectId = (id: number) => {
    if (id) {
      setSelectId(id);
    }
  };

  const updateContains = async (updateList: string[]) => {
    const oldList = containsProps;
    setContainsProps(updateList);
    try {
      const body = {
        contains: updateList
      };
      await updatePills(selectId, body);
      getPills(selectId);
    } catch (error) {
      setContainsProps(oldList);
      errorMessage();
    }
  };

  const handleChangePills = async (index: number, prop: string) => {
    const newContains = [
      index === 0 ? prop : containsProps?.[0] || '',
      index === 1 ? prop : containsProps?.[1] || '',
      index === 2 ? prop : containsProps?.[2] || ''
    ];
    await updateContains(newContains);
  };

  const getPills = async (categoryId: number) => {
    try {
      const dataPills = await getCategoryPills(categoryId);
      if (dataPills && dataPills?.contains) {
        setContainsProps(dataPills.contains);
      } else {
        setContainsProps([]);
      }
      if (dataPills && dataPills?.available) {
        setAvailable(dataPills.available);
      } else {
        setAvailable([]);
      }
    } catch (error) {
      errorMessage();
    }
  };

  useEffect(() => {
    if (selectId) {
      getPills(selectId);
    }
  }, [selectId]);

  useEffect(() => {
    getCategoriesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ChargerModule headerInfo={headerInfo} infoSideBar={infoSideBar}>
      <div id="pillsModule">
        <div className="container">
          {loading ? (
            <PillsSkeleton />
          ) : (
            <>
              <TabsCategories
                categoryList={categoryList}
                selectId={selectId}
                handleChangSelectId={handleChangSelectId}
              />

              <Properties available={available} containsProps={containsProps} handleChangePills={handleChangePills} />
            </>
          )}
        </div>
      </div>
    </ChargerModule>
  );
};

export default Pills;
